import React from "react";
import Slider from "react-slick";
import ConteudoModel from "../model/ConteudoModel";
import ConfiguracoesCarrosselPadrao from "./ConfiguracoesCarrosselPadrao";
import ReactDOM from "react-dom";
import ConteudoItem from "./ConteudoItem";
import { Link } from "react-router-dom";

type GrupoConteudosProps = {
  titulo: string;
  items: ConteudoModel[] | null;
  linkMais?: string;
  parent?: React.Component;
};

class GrupoConteudos extends React.Component<GrupoConteudosProps, {}> {
  constructor(props: GrupoConteudosProps) {
    super(props);

    this.updateImages = this.updateImages.bind(this);
  }

  componentDidUpdate(prevProps: GrupoConteudosProps, prevState: any): any {
    this.updateImages();
  }

  componentDidMount(): any {
    this.updateImages();
  }

  updateImages(): any {
    const el: any = ReactDOM.findDOMNode(this.refs.items);
    if (el) {
      const items: any = el.getElementsByClassName("content");
      for (const item of items) {
        item.style.backgroundImage = `url(${item.attributes["data-bg"].value})`;
      }
    }
  }

  render(): any {
    const { titulo, items, linkMais } = this.props;

    if (items && items.length === 0) {
      return null;
    }

    return (
      <div className="product-group">
        <div className="header">
          <h2>{titulo}</h2>
          {linkMais && linkMais.length > 0 && (
            <div className="more">
              <Link to={linkMais}>Ver mais</Link>
            </div>
          )}
        </div>
        <div className="products content">
          <Slider
            {...ConfiguracoesCarrosselPadrao}
            className="items"
            ref="items"
          >
            {items &&
              items.map((item: ConteudoModel) => (
                <ConteudoItem
                  item={item}
                  parent={this.props.parent ? this.props.parent : this}
                  key={item.conteudoId}
                ></ConteudoItem>
              ))}
            {linkMais && linkMais.length > 0 && (
              <div className="item more">
                <div>
                  <img
                    src="assets/images/icons/ver-mais-sem-foto.svg"
                    title="Ver mais"
                    alt="Ver mais"
                  />
                  <Link to={linkMais}>Ver mais</Link>
                </div>
              </div>
            )}
          </Slider>
        </div>
      </div>
    );
  }
}

export default GrupoConteudos;
